import { setInnerPagesCountAction as setInnerPagesCountOperation } from 'editor/src/store/design/slice';

export default setInnerPagesCountOperation;
